import React, { Component } from 'react';
import { withRouter } from './withRouter';

class NavMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pathname: '',
        }
    }

    checkurl = (e, path) => {
        if (e) e.preventDefault();
        this.props.navigate(path);
    }

    componentDidMount() {
        const pathname = window.location.pathname.replace('/', '').trim();
        this.setState({ pathname });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            const pathname = this.props.location.pathname.replace('/', '').trim();
            this.setState({ pathname });
        }
    }

    render() {
        const { pathname } = this.state;
        const token = window.localStorage.getItem('auth_token') || window.localStorage.getItem('token');
        if (!token) return null;

        const isHome = pathname === '' || pathname === 'home';
        const isFund = pathname === 'deposit' || pathname === 'withdraw';
        const isProfile = pathname === 'profile';
        const isRebate = pathname === 'rebate';

        return (
            <div className="bottom-navbar-container">
                <div className="bn-content">
                    <div className="bn-menu" style={{ cursor: 'pointer' }} onClick={(e) => this.checkurl(e, "/")}>
                        <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/home_ov.svg" className={`bn-icon${isHome ? ' bn-icon-active' : ''}`} alt="" />
                        <p className={`bn-desc${isHome ? ' bn-desc-active' : ''}`}>หน้าหลัก</p>
                    </div>
                    <div className="bn-menu" style={{ cursor: 'pointer' }} onClick={(e) => this.checkurl(e, "/deposit")}>
                        <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/fund_of.svg" className={`bn-icon${isFund ? ' bn-icon-active' : ''}`} alt="" />
                        <p className={`bn-desc${isFund ? ' bn-desc-active' : ''}`}>เงินทุน</p>
                    </div>
                    <div className="bn-menu" style={{ cursor: 'pointer' }} onClick={(e) => this.checkurl(e, "/rebate")}>
                        <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/instant-rebate-icon.gif" className={`bn-icon${isRebate ? ' bn-icon-active' : ''}`} alt="" />
                        <p className={`bn-desc${isRebate ? ' bn-desc-active' : ''}`}>เงินคืนทันที</p>
                    </div>
                    <div className="bn-menu" style={{ cursor: 'pointer' }} onClick={(e) => this.checkurl(e, "/profile")}>
                        <img loading="lazy" src="/build/web/igame-index-lobby-wm/img/profile_of.svg" className={`bn-icon${isProfile ? ' bn-icon-active' : ''}`} alt="" />
                        <p className={`bn-desc${isProfile ? ' bn-desc-active' : ''}`}>บัญชีของฉัน</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(NavMenu);
